import { FaClock } from "react-icons/fa";

export type Schedule = {
  day: string;
  since: string;
  to: string;
};

type ScheduleDisplayProps = {
  schedule: Schedule[];
  translations: Record<string, string>;
};

const ScheduleDisplay = ({ schedule, translations }: ScheduleDisplayProps) => {
  if (!schedule || schedule.length === 0) return null;
  return (
    <div className="rounded-md border border-gray-200 bg-white p-3">
      <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-gray-700">
        <FaClock className="text-gray-500" />
        <span>{translations.chooseCareerSchedule || "Horarios"}</span>
      </div>
      <ul className="space-y-1 text-sm text-black list-none">
        {schedule.map((entry, index) => (
          <li key={index} className="rounded bg-gray-50 px-2 py-1">
            {translations[entry.day.toLowerCase()] || entry.day}: {entry.since} - {entry.to}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScheduleDisplay;
